import { masterChatOrchestrate } from '../../../lib/backend/chat';
import { getAccessToken } from './openclawSession';

export async function orchestrateMasterChat(message, mentionedAgentId = null) {
  const token = await getAccessToken();
  return masterChatOrchestrate(token, message, mentionedAgentId);
}
